import { SelectProps, Input, Form, Select } from "antd";
import { CheckOutlined } from '@ant-design/icons';


export const MySelect = (props: SelectProps) => {


    const { status, errors } = Form.Item.useStatus();


    return (
        <Select style={{
            height: 50,
            borderRadius: 5,
            color:'rgba(0,0,0,0.5)'
        }}
            styles={
                {
                    root: {
                        borderColor: (status === 'success' && props.value) ? '#94C185' : undefined,
                    },
                }
            }
            {...props}

        />
    )
}